import * as z from "zod";

// tRPC reports the HTTP status in up to three places depending on where the
// error surfaced (procedure data, error shape, or the raw fetch response).
const trpcErrorWithStatusSchema = z.object({
  data: z.object({ httpStatus: z.number().optional() }).optional(),
  shape: z
    .object({
      data: z.object({ httpStatus: z.number().optional() }).optional(),
    })
    .optional(),
  meta: z
    .object({
      response: z.object({ status: z.number().optional() }).optional(),
    })
    .optional(),
});

export function getTRPCErrorStatus(error: unknown): number | undefined {
  const result = trpcErrorWithStatusSchema.safeParse(error);
  if (!result.success) {
    return undefined;
  }
  return (
    result.data.data?.httpStatus ??
    result.data.shape?.data?.httpStatus ??
    result.data.meta?.response?.status
  );
}
